export default "__VITE_ASSET__CAEoquwD__"